import {Calendar_First_Direction} from "@generated/graphql";

export const directionFilesBackgroundColor = '#F3F3F8';

export const calendarFirstDirectionChoices = [
  {id: Calendar_First_Direction.PatriotismAndHistoricalMemory, name: 'Патриотизм и историческая память'},
  {id: Calendar_First_Direction.EducationAndKnowledge, name: 'Образование и знания'},
  {id: Calendar_First_Direction.Volunteering, name: 'Волонтерство и добровольчество'},
  {id: Calendar_First_Direction.CultureAndArt, name: 'Культура и искусство'},
  {
    id: Calendar_First_Direction.DiplomacyAndInternationalRelations,
    name: 'Дипломатия и международные отношения',
  },
  {id: Calendar_First_Direction.MediaAndCommunications, name: 'Медиа и коммуникации'},
  {id: Calendar_First_Direction.CommunityNativeFavorite, name: 'Сообщество «Родные – любимые»'},
  {id: Calendar_First_Direction.Sport, name: 'Спорт'},
  {id: Calendar_First_Direction.WorkProfessionAndOwnBusiness, name: 'Труд, профессия и свое дело'},
  {id: Calendar_First_Direction.ScienceAndTechnology, name: 'Наука и технологии'},
  {id: Calendar_First_Direction.TourismAndTravel, name: 'Туризм и путешествия'},
  {id: Calendar_First_Direction.EcologyAndNatureProtection, name: 'Экология и охрана природы'},
  {id: Calendar_First_Direction.HealthyLifestyle, name: 'Здоровый образ жизни'},
];
